import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { SharedService } from '../../shared/service/shared.service';
import { Subject } from 'rxjs';
@Injectable()
export class JobseekerService {
  SITE_API_URL: any = '';
  data: any = {};

  // private toggleChatCardSource = new Subject<void>();
  // toggleChatCard$ = this.toggleChatCardSource.asObservable();
  // Define constructor
  constructor(public sharedService: SharedService) {
    this.SITE_API_URL = environment.API_URL;
  }

  /** This function are used for get the jobseeker purchased services list.  */
  getPurchasedServicesList = (formData: any): any => {
    const methodName = 'jobseeker_purchased_services';
    const methodUrl = environment.API_URL + methodName;
    this.data = {};
    this.data.data = formData;
    return this.sharedService.getPost(methodUrl, this.data);
  };


  sendmessage = (formData : any): any => {
		const methodName					=	'employer_chat';
		const methodUrl						=	environment.API_URL + methodName;
		// this.data							=	{};
		// this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, formData); 
	}
	

		/** This function are used for get category dropdown.  */





		  getmessagelists = (formData : any): any => {
			const methodName					=	'employer_message_list';
			const methodUrl						=	environment.API_URL + methodName;
			this.data							=	{};
			this.data.data						=	formData;
			return this.sharedService.getPost(methodUrl, this.data);


		}

  /** This function are used for get the jobseeker dashboad data.  */
  getJobseekerData = (formData: any): any => {
    const methodName = 'get_jobseeker_dashboard';
    const methodUrl = environment.API_URL + methodName;
    this.data = {};
    this.data.data = formData;
    return this.sharedService.getPost(methodUrl, this.data);
  };
  /** This function are used for get the jobseeker dashboad data.  */

  /** This function are used to update jobseeker profile.  */
  submitJobseekerData = (formData: any): any => {
    const methodName = 'edit_jobseeker_profile';
    const methodUrl = environment.API_URL + methodName;
    return this.sharedService.getPostImage(methodUrl, formData);
  };



  submitimageData = (formData: any): any => {
    const methodName = 'update_profile_image';
    const methodUrl = environment.API_URL + methodName;
    this.data = formData;
    return this.sharedService.getPost(methodUrl, this.data);
  };


  getCoverletter = (formData: any): any => {
    const methodName = 'all_cover_letters';
    const methodUrl = environment.API_URL + methodName;
    this.data = formData;
    return this.sharedService.getPost(methodUrl, this.data);
  };



  submitCoverletterData = (formData: any): any => {
    const methodName = 'create_cover_letter';
    const methodUrl = environment.API_URL + methodName;
    return this.sharedService.getPostImage(methodUrl, formData);
  };
  /** This function are used to update jobseeker profile.  */
  resumeupdateData = (formData: any): any => {
    const methodName = 'resume_status_update';
    const methodUrl = environment.API_URL + methodName;
    return this.sharedService.getPostImage(methodUrl, formData);
  };


  acceptinterview = (formData: any): any => {
    const methodName = 'accept_interview';
    const methodUrl = environment.API_URL + methodName;
    return this.sharedService.getPostImage(methodUrl, formData);
  };
  
  cancelinterview = (formData: any): any => {
    const methodName = 'UNAVAILABLE_INTERVIEW';
    const methodUrl = environment.API_URL + methodName;
    return this.sharedService.getPostImage(methodUrl, formData);
  };
  

  notintrested = (formData: any): any => {
    const methodName = 'not_interested_interview';
    const methodUrl = environment.API_URL + methodName;
    return this.sharedService.getPostImage(methodUrl, formData);
  };
  

  suggestdate = (formData: any): any => {
    const methodName = 'suggest_interview_date';
    const methodUrl = environment.API_URL + methodName;
    return this.sharedService.getPostImage(methodUrl, formData);
  };
  

  deletecoverData = (formData: any): any => {
    const methodName = 'delete_cover_letter';
    const methodUrl = environment.API_URL + methodName;
    return this.sharedService.getPostImage(methodUrl, formData);
  };


  getsingleCoverletter = (formData: any): any => {
    const methodName = 'get_cover_letter';
    const methodUrl = environment.API_URL + methodName;
    this.data = formData;
    return this.sharedService.getPost(methodUrl, this.data);
  };
  /** This function is used to update employment history.  */
  submitJobseekerEmpHistory = (formData: any): any => {
    const methodName = 'update_employment_history';
    const methodUrl = environment.API_URL + methodName;
    return this.sharedService.getPostImage(methodUrl, formData);
  };

  /** This function are used to update the certificate.  */
  submitCertificateData = (formData: any): any => {
    const methodName = 'update_certificate';
    const methodUrl = environment.API_URL + methodName;
    this.data = {};
    this.data.data = formData;
    return this.sharedService.getPost(methodUrl, this.data);
  };


  getChatuser(formData: any): any {
    const methodName = 'chat_user_names';
    const methodUrl = environment.API_URL + methodName; 
    
    return this.sharedService.getPost(methodUrl, formData);
    }



    
  /** This function are used for get the master value.  */
  getDropdown = (formData: any): any => {
    const methodName = 'get_master_value';
    const methodUrl = environment.API_URL + methodName;
    this.data = {};
    this.data.data = formData;
    return this.sharedService.getPost(methodUrl, this.data);
  };

  getJobcategory = (formData: any): any => {
    const methodName = 'job_category';
    const methodUrl = environment.API_URL + methodName;
    this.data = {};
    this.data.data = formData;
    return this.sharedService.getPost(methodUrl, this.data);
  };


  /** This function are used to get saved jobs list.  */
  getSavedJobs = (formData: any): any => {
    const methodName = 'saved_jobs_list';
    const methodUrl = environment.API_URL + methodName;
    this.data = {};
    this.data.data = formData;
    return this.sharedService.getPost(methodUrl, this.data);
  };

  getMatchedJobs = (formData: any): any => {
    const methodName = 'matched_jobs_list';
    const methodUrl = environment.API_URL + methodName;
    this.data = {};
    this.data.data = formData;
    return this.sharedService.getPost(methodUrl, this.data);
  };




  // triggerToggleChatCard() {
  //   // alert('9999')
  //   // this.toggleChatCardSource.next();
  // }


  /** This function are used for get the applied jobs  */
  getAppliedJob = (formData: any): any => {
    const methodName = 'apply_jobs_list';
    const methodUrl = environment.API_URL + methodName;
    this.data = {};
    this.data.data = formData;
    return this.sharedService.getPost(methodUrl, this.data);
  };

  /** This function are used for get save jobs and wishlist data */
  getWishlistJobs = (formData: any): any => {
    const methodName = 'get_wishlist_saved_jobs';
    const methodUrl = environment.API_URL + methodName;
    this.data = {};
    this.data.data = formData;
    return this.sharedService.getPost(methodUrl, this.data);
  };
  /** This function are used for get save jobs and wishlist data */

  /** This function are used for get the saved jobs   */
  saveWishlistJobs = (formData: any): any => {
    const methodName = 'add_user_wishlist';
    const methodUrl = environment.API_URL + methodName;
    this.data = {};
    this.data.data = formData;
    return this.sharedService.getPost(methodUrl, this.data);
  };
  /** This function are used for get the saved jobs   */

  /** This function are used for get the apply for jobs  */
  appliedJob = (formData: any): any => {
    const methodName = 'job_apply';
    const methodUrl = environment.API_URL + methodName;
    this.data = {};
    this.data.data = formData;
    return this.sharedService.getPost(methodUrl, this.data);
  };
  /** This function are used for get the apply for jobs    */

  /** This function are used for get category dropdown.  */
  getCategoryDropdown = (formData: any): any => {
    const methodName = 'get_category_dropdown';
    const methodUrl = environment.API_URL + methodName;
    this.data = {};
    this.data.data = formData;
    return this.sharedService.getPost(methodUrl, this.data);
  };
  /** This function are used for get category dropdown.  */

  /** This function are used for get purchased resume template list.  */
  getPurchaseTemplateList = (formData: any): any => {
    const methodName = 'get_purchase_template_list';
    const methodUrl = environment.API_URL + methodName;
    this.data = {};
    this.data.data = formData;
    return this.sharedService.getPost(methodUrl, this.data);
  };
  /** This function are used for get purchased resume template list.  */
}
